let vibe_cake_masters_testimonials_carousel = function( $ ) {

	let $carousel;

	let _init = function() {
		$carousel = $( '#masters-landing-page-testimonials .carousel' );

		if ( $carousel.length > 0 ) {
			_setup_carousel();
		}
	};

	let _setup_carousel = function() {
		$carousel.owlCarousel( {
			items: 1,
			nav: false, // Not sure why this is not working so we hide it in the css
			dots: true,
			loop: true,
			autoplay: true,
			autoplayTimeout: 10000,
		} );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = vibe_cake_masters_testimonials_carousel;